"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerHostedLivestreamCtaContainerProperty = exports.partnerHostedLivestreamCtaContainerPropertyDefinition = void 0;
exports.partnerHostedLivestreamCtaContainerPropertyDefinition = {
    view: { label: 'CTA' },
    constraints: [
        {
            name: 'properties',
            argument: ['partner-hosted-livestream-cta-url'],
        },
    ],
    type: 'container',
    multiple: false,
    name: 'partner-hosted-livestream-cta-container',
};
const isPartnerHostedLivestreamCtaContainerProperty = (prop) => {
    return prop.name === exports.partnerHostedLivestreamCtaContainerPropertyDefinition.name;
};
exports.isPartnerHostedLivestreamCtaContainerProperty = isPartnerHostedLivestreamCtaContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1jdGEtY29udGFpbmVyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcGFydG5lci1ob3N0ZWQtbGl2ZXN0cmVhbS1jdGEtY29udGFpbmVyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscURBQXFELEdBQUc7SUFDbkUsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRTtJQUN0QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxZQUFZO1lBQ2xCLFFBQVEsRUFBRSxDQUFDLG1DQUFtQyxDQUFDO1NBQ2hEO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSx5Q0FBeUM7Q0FDaEIsQ0FBQTtBQUkxQixNQUFNLDZDQUE2QyxHQUFHLENBQUMsSUFBa0IsRUFBdUQsRUFBRTtJQUN2SSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssNkRBQXFELENBQUMsSUFBSSxDQUFBO0FBQ2pGLENBQUMsQ0FBQTtBQUZZLFFBQUEsNkNBQTZDLGlEQUV6RCJ9